export default "__VITE_ASSET__DnO82eRW__"